import { PageState } from 'models/PageState';
import { AddressInfo } from 'models/AddressInfo';
import { isCheckoutPage } from 'models/CheckoutPageModel';

const DEFAULT_MAX_NAME_LENGTH = 100;

export const selectNeedsCertificateId = (state: PageState) => {
  return state.cart.needsCertificateId;
};

export const selectAddressInfo = ({ currentPage }: PageState): AddressInfo | null => {
  if (!isCheckoutPage(currentPage)) {
    return null;
  }

  return currentPage.addressInfo;
};

export const selectNameMaxLength = ({ currentPage }: PageState): number | undefined => {
  if (!isCheckoutPage(currentPage)) {
    return undefined;
  }

  return currentPage.initialValues.address.maxNameLength ?? DEFAULT_MAX_NAME_LENGTH;
};
